module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11\" height=\"13\" viewBox=\"0 0 11 13\"><path d=\"M11 13V0H1.284a1 1 0 0 0-.735 1.678L11 13z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Card/bubble-tip-logo.svg
// module id = 781
// module chunks = 0